import { clearAuthSession, getAuthToken } from '@/lib/pwaSession';

/** JWT absent ou expiré → inscription (pas connexion). */
export const SIGNUP_SCREEN_PATH = '/sign-up-login-screen?mode=signup';

export const LOGIN_SCREEN_PATH = '/sign-up-login-screen?mode=login';

/** Session invalide : efface le jeton et renvoie vers l’inscription. */
export function redirectToSignup(returnPath?: string): void {
  if (typeof window === 'undefined') return;
  clearAuthSession();
  const params = new URLSearchParams({ mode: 'signup' });
  if (returnPath?.startsWith('/') && !returnPath.startsWith('//')) {
    params.set('return', returnPath);
  }
  window.location.replace(`/sign-up-login-screen?${params.toString()}`);
}

/** Déconnexion volontaire → écran connexion. */
export function redirectToLogin(): void {
  if (typeof window === 'undefined') return;
  clearAuthSession();
  window.location.replace(LOGIN_SCREEN_PATH);
}

/** JWT absent, expiré ou réponse API 401 / 403 auth. */
export function isApiUnauthorized(
  response: Response,
  parsed: { success?: boolean; data?: { message?: string } } | null,
): boolean {
  if (response.status === 401) return true;

  if (response.status === 403) {
    if (!parsed) return true;

    const msg = String(parsed.data?.message || '').toLowerCase();
    if (
      msg.includes('abonnement') ||
      msg.includes('subscription') ||
      msg.includes('forfait')
    ) {
      return false;
    }

    return (
      !parsed.success ||
      msg.includes('token') ||
      msg.includes('expir') ||
      msg.includes('session') ||
      msg.includes('forbidden') ||
      msg.includes('access') ||
      msg.includes('invalid')
    );
  }

  return false;
}

/** Redirige vers l’inscription si la session est invalide. Retourne true si redirection faite. */
export function handleApiUnauthorized(
  response: Response,
  parsed: { success?: boolean; data?: { message?: string } } | null,
): boolean {
  if (!isApiUnauthorized(response, parsed)) return false;
  redirectToSignup(`${window.location.pathname}${window.location.search}`);
  return true;
}

/** Jeton requis pour une page protégée ; redirige si absent ou expiré. */
export function requireAuthToken(): string | null {
  const token = getAuthToken();
  if (!token) {
    redirectToSignup(`${window.location.pathname}${window.location.search}`);
    return null;
  }
  return token;
}

export function authHeaders(token?: string | null): HeadersInit {
  const t = token ?? getAuthToken();
  if (!t) return {};
  return { Authorization: `Bearer ${t}` };
}
